<template>
        <v-card class="pa-12"
                color="indigo darken-2"
                flat>
            <v-card elevation="12"
                    width="256">
                <v-navigation-drawer floating
                                     permanent>
                        <v-list dense
                                rounded>
                            <v-list-item v-for="item in items"
                                         :key="item.title"
                                         link
                                         :to="item.path">
                                <v-list-item-icon>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item-content>                                
                            </v-list-item>
                        </v-list>
                </v-navigation-drawer>
            </v-card>
        </v-card>
</template>

<script>
    export default {
        data() {
            return {
                items: [
                    { title: 'Clients', icon: 'mdi-forum', path: '/Clients' },
                ],
            }
        },
    }
</script>